export const removeAttributesOnElement = (element) => {
    const attributes = [...element.attributes];
    attributes.forEach((attribute) => element.removeAttribute(attribute.name));
};
export const traverseChildren = (element, callback) => {
    callback(element);
    const children = [...element.children];
    children.forEach((child) => {
        // Check if the element is a link
        if (child.tagName.toLowerCase() === 'a') {
            // Skip processing link elements
            return;
        }
        traverseChildren(child, callback);
    });
};
export const removeAttributes = (elements) => {
    const elementsArray = [...elements];
    elementsArray.forEach((element) => {
        // Check if the element is a link
        if (element.tagName.toLowerCase() === 'a') {
            // Skip processing link elements
            return;
        }
        // Otherwise, traverse children and remove attributes
        traverseChildren(element, removeAttributesOnElement);
    });
};
export const wrapElements = (elements, config) => {
    const elementsArray = [...elements];
    elementsArray.forEach((element) => {
        const wrapper = document.createElement(config.tagName || 'div');
        config?.attributes?.forEach((attribute) => wrapper.setAttribute(attribute.name, attribute.value));
        element.parentNode?.insertBefore(wrapper, element);
        wrapper.appendChild(element);
        config.callback && config.callback(wrapper, config?.additional?.classLarge);
    });
};
export const setElementClassByContainerWith = (element, classLarge, classSmall) => {
    const checkWidth = (element) => {
        const child = element.children?.[0];
        if (!child)
            return;
        const widthChild = child.getBoundingClientRect().width;
        const widthElement = element?.getBoundingClientRect().width || 0;
        if (widthElement < widthChild) {
            classLarge && element.classList.add(classLarge);
            classSmall && element.classList.remove(classSmall);
        }
        else {
            classSmall && element.classList.add(classSmall);
            classLarge && element.classList.remove(classLarge);
        }
    };
    checkWidth(element);
    const mql = window.matchMedia('(min-width: 1024px)');
    mql.addEventListener('change', () => checkWidth(element));
};
